/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { reasonEnumSchema } from "./reasonEnumSchema.ts";

export const callStaffTgBotRequestRequestSchema = z.object({
	button_id: z.uuid().optional(),
	reason: reasonEnumSchema
		.optional()
		.default("request_waiter")
		.describe("* `request_waiter` - Вызов официанта\n* `request_bill` - Запрос счёта\n* `request_hookah` - Запрос кальяна"),
});
